export default __webpack_public_path__ + "static/media/reen.93f0e2f7.svg";